
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blogs/[blog]",
      function () {
        return require("private-next-pages/blogs/[blog]/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blogs/[blog]"])
      });
    }
  